import { Scroll } from "@lib/scroll";
import { runMount, runPageIn } from "./modules/_";
import { createCycles } from "./modules/_";
// import { Pages } from "@lib/pages";

// history.scrollRestoration = "manual";

class _App {
  private scroll = Scroll;
  // pages = Pages;

  constructor() {
    // console.log("ffs!");
    createCycles();
    runPageIn();
    runMount();
  }
}

export const App = new _App();
